import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Swiper from 'react-id-swiper';
import { Tab, TabList, TabPanel } from 'react-tabs';
import { selectProduct, updateProduct } from '../../redux/actions';
import { Tabs } from "../../containers";

import {
  HotelDescriptionSection,
  HotelDescriptionContainer,
  HotelTab,
  HotelContent,
  HotelImage,
  HotelHeading,
  HotelDetailedDescription
} from './styles';

const mapStateToProps = state => ({
  userProduct: state.userProduct,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleProductSelect: selectProduct,
  handleProductChange: updateProduct,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class HotelDescription extends Component {
  static propTypes = {
    products: PropTypes.instanceOf(Array),
    userProduct: PropTypes.instanceOf(Object),
    handleProductChange: PropTypes.func,
  };

  render() {
    const { products, userProduct, handleProductChange } = this.props;
    const { product } = userProduct;

    const centered = {
      margin: '0 auto',
      width: '100%',
    };

    const params = {
      slidesPerView: 'auto',
      freeMode: true,
      resistanceRatio : 0
    };

    return (
      <HotelDescriptionSection>
        <HotelDescriptionContainer>
          <Tabs selectedIndex={product.index} onSelect={index => handleProductChange(products[index].name)}>
            <TabList>
              <Swiper
                {...params}
              >
                {products.map(child => <Tab key={child.name}>{child.name}</Tab>)}
              </Swiper>
            </TabList>
            {products.map(child => {
              const { name, id, image, description } = child;

              return (
                <TabPanel key={id}>
                  <HotelTab>
                    <HotelImage style={description ? {} : centered}>
                      <img src={`${process.env.CDN_URL}${image}`} alt={name} />
                    </HotelImage>
                    {description && (
                      <HotelContent>
                        <HotelHeading>What you get</HotelHeading>
                        <HotelDetailedDescription as="div" dangerouslySetInnerHTML={{ __html: description.replace(/(style="[^"]*")|(&nbsp;)/g, " ") }} />
                      </HotelContent>
                    )}
                  </HotelTab>
                </TabPanel>
              )
            })}
          </Tabs>
        </HotelDescriptionContainer>
      </HotelDescriptionSection>
    )
  }
}

export default HotelDescription;
